import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  min-height: 32px;
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const Name = styled.span`
  color: #000;
`;

export const Link = styled.a.attrs({ className: 'btn btn-link p-0' })`
  line-height: 1.2;
  text-align: left;
`;
